export default "__VITE_ASSET__OqvUWSsE__"